declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveCounsellingActivityRequest, SaveTestCycleActivitiesRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, SaveTestMedCycleActivitiesRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, TestData } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSelectActivityModal } from './selectactivity.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomCodeTypeRequest, CustomCodeValuesController } from '../../../../custumcomponents/ddlbyrequesttype/customdatabyrequesttype.interface';
import { CUstomDataByRequestTypeService } from '../../../../custumcomponents/ddlbyrequesttype/customdatabyrequesttype.service';
//import { getUTCDate } from 'NgbDateParserFormatter';
import { Pipe } from '@angular/core';
import { Injectable } from '@angular/core';
import { PipeTransform } from '@angular/core';
@Pipe({
    name: 'TestPipe'
})

@Injectable()
export class TestsInfoPipe implements PipeTransform {

    transform(value: CustomCodeValuesController[], filter: string): CustomCodeValuesController[] {
        filter = filter ? filter.toLocaleLowerCase() : null;
        return filter ? value.filter((app: CustomCodeValuesController) =>
            app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1
           
        ) : value;
    }

}
@Component({
    selector: 'ngbeventadd',
    templateUrl: './eventadd.modal.html',
    styleUrls: ['./eventadd.modal.scss']
})

export class NgbEventAddModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;

    @Input() IsShowDetail: boolean = false;
    @Input() ModalName: string;
    //@Input() OwnerName: string;
    //@Input() OwnerFormattedCode: string;
    //@Input() OwnerPatientImageFile: string;
    //@Input() Protocol: string;
    //@Input() OwnerGender: number;
    //@Input() OwnerAgeYears: number;
    @Input() ActorCodeNew: number;
    @Input() ActivityName: string;
    @Input() CycleCode: number;
    @Input() Plancode: number;
    @Input() LMPDate: Date;
    @Input() Doc1: string;
    @Input() Antag: string;
  @Input() Stimulation: string;
  @Input() TCModelName: string;
    public Activitytype2: string;
    //@Input() CurrentActorEditEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    public ApiResData: ApiResponseModel;
    DOB: NgbDateStruct;
    DateOfBirth: NgbDateStruct;
    ScheduleDate: NgbDateStruct;
    ScheduleDate2: NgbDateStruct;
    ScheduleMedicineDate: NgbDateStruct;
    ScheduleGeneralDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    minDate: NgbDateStruct;
    NewDate: Date = new Date();
    ActivityDate: Date;
    //LMPDate: Date;
    //getDay: Date;
    LMPNew: NgbDateStruct;
    public CurrentDay: number;
    public LMPDay: number;
    public ActivityTypeSelected: string;
    //DocNew:Date;
    //  DateNew: any;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    public PatientName: string;
    CurrentSaveTestCycleActivitiesRequest: SaveTestCycleActivitiesRequest;
    CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    PlanDetails: TreatmentCyclesByActorCodeController;
    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCodeNew;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.CurrentTreatmentCyclesByActorCodeController[0].LMP;
                    //var LMPDate = this.CurrentTreatmentCyclesByActorCodeController[0].LMP;
                    //this.LMPDay = LMPDate[8] + LMPDate[9];
                    //alert(this.LMPDay);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //public IsSelected: boolean;
    constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private parserFormatter: NgbDateParserFormatter,
        private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
        private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, public CUstomDataByRequestTypeService: CUstomDataByRequestTypeService, private filter: TestsInfoPipe) { }
    ActorCode: number;
    CurrentDate: any;
    Doc: number;
    Datenew: Date;
    //LMPDate: Date;
    //LMPDay: number;
    //CurrentDay: number;
    //LMPDate2: Date = this.LMPDate;


    ngOnInit() {
        this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.ShowService = false;
        this.LoadPatients();
        //this.LoadDSAData_();
        //this.GetDSAActivityByCycleCodeController_();
        //this.LoadDSAData();
        this.CurrentSaveTestMedCycleActivitiesRequest = new SaveTestMedCycleActivitiesRequest();
        this.CurrentSaveTestMedCycleActivitiesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

        //this.LMPDate = new Date();
        //this.LMPDay = this.LMPDate.getUTCDate();

        //this.CurrentDay = this.NewDate.getDay();
        //this.LMPDay = this.LMPDate2.getDay();
        //this.CurrentDate = new Date();
        //this.CurrentDay = this.CurrentDate.getUTCDate();
        //this.Doc = this.CurrentDay - this.LMPDay;
        //alert(this.Doc);
        //this.DateNew = new Date();
        //this.NewDate = new Date();
        //this.CurrentDate = this.NewDate.getDate();
        //this.LMPDate = this.PlanDetails.LMP;
        //this.LMPNew = { year: this.LMPDate.getFullYear(), month: this.LMPDate.getMonth(), day: this.LMPDate.getDate() };
        //this.Doc = (this.CurrentDate - this.LMPNew.day) + 1;
        //alert(this.Doc);
        //this.PatientName = this.OwnerName;
        //this.LMPDate = this.PlanDetails.LMP;
        // alert(this.LMPDate);
        this.Datenew = new Date(this.LMPDate)
        this.LMPDay = this.Datenew.getDate();
        //alert(this.LMPDay);
        this.CurrentDay = this.NewDate.getDate();
        //alert(this.CurrentDay);
        this.Doc = (this.CurrentDay - this.LMPDay) + 1;
        //alert(this.CurrentDay+this.LMPDay);
        this.LoadRegistries();
        this.CurrentSaveTestCycleActivitiesRequest = new SaveTestCycleActivitiesRequest();
        this.CurrentSaveTestCycleActivitiesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.ActivityTypeSelected = this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType;
        //alert(this.ActivityTypeSelected);
        //if (this.ActivityTypeSelected != "") {
        //    this.LoadDSAData();
        //}
        this.CustomDataoptions();
    }
    CurrentCustomCodeTypeRequest: CustomCodeTypeRequest;
    CustomValues: CustomCodeValuesController[];

    CustomDataoptions(){
        this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
        this.CurrentCustomCodeTypeRequest.RequestedType = "IvfFolScanDayTests";
        this.CurrentCustomCodeTypeRequest.FacilityCode = 0;
        this.CurrentCustomCodeTypeRequest.ActorCode = this.ActorCode;
        this.CurrentCustomCodeTypeRequest.CustomCode = 0;
        this.CurrentCustomCodeTypeRequest.CustomType = "0";
      this.CurrentCustomCodeTypeRequest.StringContains ="0";
        //this.CurrentCustomCodeTypeRequest.TestCode = this.TestCode;
        this.CurrentCustomCodeTypeRequest.MedicineCode = 0;
        this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CustomValues;
      this.GetTestsData(this.CurrentCustomCodeTypeRequest);
    }
    GetTestsData(SendCustomCodeTypeRequest: CustomCodeTypeRequest): void {
        this.StartRefreshing();

        this.CUstomDataByRequestTypeService.GetCustomDataByRequestedType(SendCustomCodeTypeRequest).subscribe
            (
                (result) => {
                    this.ApiResData = result;
                    if (!this.ApiResData.hasError) {
                        //  console.log('GetActorProfileController');
                        this.CustomValues = this.ApiResData.Result;                      
                        this.pdata = this.CustomValues;

                        //alert(this.CustomValues[0].Code);

                        this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        if (this.ApiResData.ErrorData != "") {

                            alert(this.ApiResData.ErrorData);
                        }
                        else {
                            alert(' Failed Due to Internal Error.... Please Contact Admin..');
                        }
                    }

                },
                //(ddlRefferedType) => {
                //    this.ddlRefferedType = ddlRefferedType;
                //    this.stopRefreshing();



                //},

                (error) => {

                    if (error == "401 - Unauthorized") {
                        // alert(error);
                        this.stopRefreshing();



                    }
                    else {
                        // alert(error);
                        this.stopRefreshing();
                    }
                }
            );;

    }

        onChange2(event: any) {
        // this.Activitytype2 = event;
        if (event != null) {
            this.LoadDSAData(event);
        }
    }

    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    // DSADetails: DSAActivityByCycleCodeController;
    //DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData(ActivityType: string) {
        // alert("ScansData");
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(ActivityType, this.ActivityName);
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 20;
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;


        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    //this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.PlanDetails.EggSourceType, this.ActivityName), this.PlanDetails.ProtocolStartDate)[0];
                    // this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularScanEndInfo.ScanDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }


    onChange(Event: any) {
        if (Event != null) {
            var a = this.CurrentDSAActivityByCycleCodeController.filter(X => X.DSA === Event)
            if (a.length > 0) {
                this.ActivityDate = a[0].ActivityDate;
                // alert(this.ActivityDate);
            }
        }
    }

    LoadRegistries() {
        this.StartRefreshing();



        //this.GetBranchMap();


    }
    GetActorCode(ActvityType: string, ActivityName: string): number {
        if (ActvityType == 'SELF') {
            var ActorCodeNewOne = this.PlanDetails.EggActorCode;
            return ActorCodeNewOne;
        }
        else if (ActvityType == 'DONOR') {
            var ActorCodeNewOne = this.PlanDetails.EggActorCode;
            return ActorCodeNewOne;
        }
        else if (ActvityType == 'RECIPIENT') {
            var ActorCodeNewOne = this.PlanDetails.RecepientActorCode;
            return ActorCodeNewOne;
        }
        else if (ActivityName == 'FollicularScanSelf' || ActivityName == 'PickupSelf' || ActivityName == 'ETSelf' || ActivityName == 'PregencySelf') {
            var ActorCodeNewOne = this.PlanDetails.EggActorCode;
            return ActorCodeNewOne;
        }
        else if (ActivityName == 'FollicularScanEgg' || ActivityName == 'PickupEgg') {
            var ActorCodeNewOne = this.PlanDetails.EggActorCode;
            return ActorCodeNewOne;
        }
        else if (ActivityName == 'ETREC' || ActivityName == 'PregencyREC') {
            var ActorCodeNewOne = this.PlanDetails.RecepientActorCode;
            return ActorCodeNewOne;
        }

    }

    //Lmpnumber: any;



    onSubmit() {
        // alert("On Submit");
        this.spinner.show();
        this.CurrentSaveTestMedCycleActivitiesRequest.PlanCode = this.Plancode;
        this.CurrentSaveTestMedCycleActivitiesRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = this.ActivityDate; //new Date(this.parserFormatter.format(this.ScheduleDate));
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "10:00";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupMode = "Email";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "Active";
        this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleActivityCode = 0;
        var SelectedTests: CustomCodeValuesController[];
       
        this.CurrentSaveTestMedCycleActivitiesRequest.TestActivityData = new Array<TestData>();
        this.CustomValues.filter(
            function (a) {
                return a.IsSelected==true

            }).forEach((v, i, a) => {
                var itemab: TestData = new TestData();
                itemab.TestCode = v.Code;
                itemab.ServiceName = v.DisplayName;
                //itemab.OocyteCount = v.OocyteCount;
                //item.OccCount = v.OccCount;
                this.CurrentSaveTestMedCycleActivitiesRequest.TestActivityData.push(itemab);
            });
      

        // alert(this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType);

        this.ActivityTypeSelected = this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType;
        //alert(this.ActivityTypeSelected);
        this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.GetActorCode(this.ActivityTypeSelected, this.ActivityName);

        //if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'SELF' || this.ActivityName == 'FollicularScanSelf' || this.ActivityName == 'PickupSelf' || this.ActivityName == 'ETSelf' || this.ActivityName == 'PregencySelf') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.EggActorCode;
        //}
        //else if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'DONOR' || this.ActivityName == 'FollicularScanEgg' || this.ActivityName == 'PickupEgg') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.EggActorCode;
        //}

        //else if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'RECIPIENT' || this.ActivityName == 'ETRec' || this.ActivityName=='PregencyRec') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.RecepientActorCode;
        //}
        //else if (this.ActiviyName == 'FollicularScanSelf' || this.ActiviyName == 'PickupSelf' || this.ActiviyName == 'ETSelf' || this.ActiviyName == 'PregencySelf') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.SelfActorCode;
        //}
        //else if (this.ActiviyName == 'FollicularScanEgg' || this.ActiviyName == 'PickupEgg' ) {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.EggActorCode;
        //}
        //elseif(this.ActiviyName=='')
        // this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.ActorCodeNew;
        this.CurrentSaveTestMedCycleActivitiesRequest.ClinicalOrderEntryCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.LoginUserActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.BasePrice = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleTestCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.Doc;
        //this.Lmpnumber = this.PlanDetails.LMP;
        //this.CurrentSaveTestCycleActivitiesRequest.Doc = (this.DateNew - this.Lmpnumber) + 1;
        //alert(this.CurrentSaveTestCycleActivitiesRequest.Doc);


        //this.CurrentSaveCounsellingActivityRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 60;

        this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.activeModal.close();
                    this.spinner.hide();
                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitFolicular() {
        // alert("On Submit");
        this.spinner.show();
        this.CurrentSaveTestMedCycleActivitiesRequest.PlanCode = this.Plancode;
        this.CurrentSaveTestMedCycleActivitiesRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = this.ActivityDate; //new Date(this.parserFormatter.format(this.ScheduleDate));
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "10:00";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupMode = "Email";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "Active";
        this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleActivityCode = 0;
        var SelectedTests: CustomCodeValuesController[];

        this.CurrentSaveTestMedCycleActivitiesRequest.TestActivityData = new Array<TestData>();
       
        var item: TestData = new TestData();
        item.TestCode = 124;
        item.ServiceName = "FOLLICULAR GROWTH SCAN";
        this.CurrentSaveTestMedCycleActivitiesRequest.TestActivityData.push(item);

        //this.CustomValues.filter(
        //    function (a) {
        //        return a.IsSelected == true

        //    }).forEach((v, i, a) => {
        //        var itemab: TestData = new TestData();
        //        itemab.TestCode = v.Code;
        //        itemab.ServiceName = v.DisplayName;
                
        //        this.CurrentSaveTestMedCycleActivitiesRequest.TestActivityData.push(itemab);
        //    });


        // alert(this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType);

        this.ActivityTypeSelected = this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType;
        //alert(this.ActivityTypeSelected);
        this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.GetActorCode(this.ActivityTypeSelected, this.ActivityName);

        //if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'SELF' || this.ActivityName == 'FollicularScanSelf' || this.ActivityName == 'PickupSelf' || this.ActivityName == 'ETSelf' || this.ActivityName == 'PregencySelf') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.EggActorCode;
        //}
        //else if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'DONOR' || this.ActivityName == 'FollicularScanEgg' || this.ActivityName == 'PickupEgg') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.EggActorCode;
        //}

        //else if (this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType == 'RECIPIENT' || this.ActivityName == 'ETRec' || this.ActivityName=='PregencyRec') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.PlanDetails.RecepientActorCode;
        //}
        //else if (this.ActiviyName == 'FollicularScanSelf' || this.ActiviyName == 'PickupSelf' || this.ActiviyName == 'ETSelf' || this.ActiviyName == 'PregencySelf') {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.SelfActorCode;
        //}
        //else if (this.ActiviyName == 'FollicularScanEgg' || this.ActiviyName == 'PickupEgg' ) {
        //    this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.EggActorCode;
        //}
        //elseif(this.ActiviyName=='')
        // this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.ActorCodeNew;
        this.CurrentSaveTestMedCycleActivitiesRequest.ClinicalOrderEntryCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.LoginUserActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.BasePrice = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleTestCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.Doc;
        //this.Lmpnumber = this.PlanDetails.LMP;
        //this.CurrentSaveTestCycleActivitiesRequest.Doc = (this.DateNew - this.Lmpnumber) + 1;
        //alert(this.CurrentSaveTestCycleActivitiesRequest.Doc);


        //this.CurrentSaveCounsellingActivityRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 60;

        this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    this.activeModal.close('Load');
                    this.spinner.hide();
                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );

    }

    onSubmitMedicine() {
        // alert("On Submit");
        this.spinner.show();
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupPlanCode = this.Plancode;
        this.CurrentSaveTestMedCycleActivitiesRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = this.ActivityDate;
        //this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = new Date(this.parserFormatter.format(this.ScheduleMedicineDate));
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupMode = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleActivityCode = 0;
        this.ActivityTypeSelected = this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.GetActorCode(this.ActivityTypeSelected, this.ActivityName);
        this.CurrentSaveTestMedCycleActivitiesRequest.ClinicalOrderEntryCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.LoginUserActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.MedicineTradeCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.MedicineTradeName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Duration = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.Frequency = "";
        //this.CurrentSaveTestMedCycleActivitiesRequest.DurationType = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.StartDate = new Date();
        this.CurrentSaveTestMedCycleActivitiesRequest.EndDate = new Date();
        this.CurrentSaveTestMedCycleActivitiesRequest.TradedDrugDetailCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DoseNumeric = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.Doc;
        //this.CurrentSaveCounsellingActivityRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 20;

        this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.activeModal.close();
                        //this.ShowList = true;
                        //this.clearData();
                        //this.LoadActivity();


                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.spinner.hide();
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );

    }
    onSubmitGeneral() {
        // alert("On Submit");
        this.spinner.show();
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = new Date(this.parserFormatter.format(this.ScheduleGeneralDate));
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.SelectActivity = this.User;
        this.CurrentSaveTestMedCycleActivitiesRequest.SelectActivityCode = this.Code;
        this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.Doc;

        //this.CurrentSaveCounsellingActivityRequest.PlanCode = this.Selectedplan.CounsellingPlanCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 30;

        this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.activeModal.close();
                        //this.ShowList = true;
                        //this.clearData();
                        //this.LoadActivity();
                        this.spinner.hide();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );

    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    pdata: any[];// = this.data;
    listFilter: string;
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CustomValues,
                    this.listFilter);
            }
        }
    }
    onAssignedToActorCode(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            //this.CurrentSaveIvfCycleTestDataRequest.TestCode = event;
            this.CurrentSaveTestMedCycleActivitiesRequest.ServiceName = event;
            // alert(this.CurrentSaveTestMedCycleActivitiesRequest.ServiceName);
            // console.log('event--_>' + event);
            //   }
        }


    }
    onAssignedToActorCode2(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            //this.CurrentSaveIvfCycleTestDataRequest.TestCode = event;
            this.CurrentSaveTestMedCycleActivitiesRequest.MedicineName = event;
            // console.log('event--_>' + event);
            //   }
        }


    }
    User: string;
    Code: number;
    Activity() {
        const modalRef = this.modalService.open(NgbSelectActivityModal,
            {
                centered: true,
                size: "lg"

            })
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.User = receivedEntry.make;
            this.Code = receivedEntry.value;
            //alert(this.Code);
        })
        modalRef.componentInstance.CycleType = this.PlanDetails.CycleType;
        modalRef.componentInstance.Protocol = this.PlanDetails.ProtocolName;
        //modalRef.componentInstance.ActorCodeNew = this.ActorCode;
        //modalRef.componentInstance.CycleCode = this.CycleCode;
        //modalRef.componentInstance.Plancode = this.PlanDetails.FollowupPlanCode;

        //modalRef.componentInstance.OwnerName = this.TreamentCycleDetails.OwnerName;
        //modalRef.componentInstance.OwnerFormattedCode = this.TreamentCycleDetails.OwnerFormattedCode;
        //modalRef.componentInstance.OwnerPatientImageFile = this.TreamentCycleDetails.OwnerPatientImageFile;
        //modalRef.componentInstance.Protocol = l.Protocol;
        //modalRef.componentInstance.OwnerGender = l.OwnerGender
        //modalRef.componentInstance.OwnerAgeYears = l.OwnerAgeYears;
        //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
    }

}
